import { useLogoutMutation } from "app/services/api/authorisationApi";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export default function useLogout() {
  const [triggerLogout] = useLogoutMutation();
  const { showErrorToast } = useDisplayToast();

  return {
    logout: async () => {
      try {
        triggerLogout();
      } catch (error) {
        showErrorToast(error);
      }
    },
  };
}
